export class UpdateTimer {
  static readonly type = '[Reservation] Update Timer';
  constructor(public countdownTime: string) {}
}
